import { StringHelpers } from "../helpers/string-helpers";
import { IChartContainer } from "../models/base/chart-container.interface";
import { IComponent } from "./component.interface";

export enum InformationPopupType {
    Normal = 0,
    TradeConfirmation = 1,
}

export class InformationPopupComponent implements IComponent {
    public id = StringHelpers.newGuid();

    private element: HTMLElement;
    private base: IChartContainer;
    private submitCallback?: Function;
    private cancelCallback?: Function;
    private showDontShowAgainCheckbox = false;

    constructor(base: IChartContainer) {
        this.base = base;
        this.create();
        this.onClick();
        this.onResize();
    }

    public show(title: string, description: string, submitCallback?: Function, informationPopupType?: InformationPopupType, cancelCallback?: Function) {
        this.submitCallback = submitCallback;
        this.cancelCallback = cancelCallback;

        if (this.submitCallback) {
            this.element.findFirst('.footer .close')?.setInnerHtml('Cancel');
            this.element.findFirst('.footer .submit')?.removeClass('hidden');
        } else {
            this.element.findFirst('.footer .close')?.setInnerHtml('Close');
            this.element.findFirst('.footer .submit')?.addClass('hidden');
        }

        const checkbox = this.element.querySelector<HTMLInputElement>('.footer .footer-checkbox input');
        if (checkbox) {
            checkbox.checked = false;
        }

        if (informationPopupType == InformationPopupType.TradeConfirmation) {
            this.showDontShowAgainCheckbox = true;
            this.element.addClass('fc');
        } else {
            this.showDontShowAgainCheckbox = false;
            this.element.removeClass('fc');
        }

        this.element.findFirst('.head p.title')?.setInnerHtml(title);

        const content = this.element.findFirst('.content') as HTMLElement | null;
        if (content) {
            this.setContentHeight(content);
            content.setInnerHtml(description);
        }

        this.element.classList.add('active');
    }

    public close() {
        this.element.classList.remove('active');
    }

    public isActive() {
        return this.element.classList.contains('active');
    }
    
    private setContentHeight(content?: HTMLElement) {
        const el = content ?? this.element.findFirst('.content') as HTMLElement | null;
        if (!el) return;
        const wrapperHeight = this.base.chartWrapper?.clientHeight ?? 0;
        el.style.maxHeight = wrapperHeight > 0 ? `${wrapperHeight - 150}px` : '';
    }

    private onResize() {
        this.base.domEvents.onResize(this.id, () => {
            this.setContentHeight();
        });
    }

    private onClick() {
        this.element.querySelectorAll<HTMLElement>('.submit').forEach((el: HTMLElement) => {
            el.addEventListener('click', () => {
                if (this.submitCallback) {
                    const dontShowAgain = this.showDontShowAgainCheckbox ? this.element.querySelector<HTMLInputElement>('.footer .footer-checkbox input')?.checked ?? false : false;
                    this.submitCallback(dontShowAgain);
                }

                this.close();
            });
        });
        this.element.querySelectorAll<HTMLElement>('.close').forEach((el: HTMLElement) => {
            el.addEventListener('click', () => {
                if (this.cancelCallback) {
                    this.cancelCallback();
                }
                this.close();
            });
        });
    }

    private create() {
        const div = document.createElement('div');
        div.className = `information-popup`;
        div.innerHTML = `
        <div class="wrapper">
            <div class="head">   
                <p class="title"></p>
                <button class="close" type="button">
                    <span class="icon">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 17" width="17" height="17" fill="currentColor">
                            <path d="m.58 1.42.82-.82 15 15-.82.82z"></path>
                            <path d="m.58 15.58 15-15 .82.82-15 15z"></path>
                        </svg>
                    </span>
                </button>
            </div>
            <div class="content">
            </div>
            <div class="footer">
                <div class="footer-checkbox">
                    <input type="checkbox" id="dont-show-again-footer" />
                    <label for="dont-show-again-footer">Don't show this again</label>
                </div>
                <button class="close">Close</button>
                <button class="submit hidden">Ok</button>
            </div>
        </div>
        `;

        this.element = div;
        this.base.chartWrapper?.insertAdjacentElement('beforeend', this.element);
    }
}